import React, { memo } from 'react';
import { BodyText } from '@swift-paypal/pp-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import renderSelect from '../../../lib/forms/select-field';

const SelectionField = ({
  children,
  label,
  error,
  touched,
  ...props
}) => (
  <>
    {label && (
      <BodyText as="label">
        {label}
      </BodyText>
    )}
    <Field
      errorText={touched && error}
      component={renderSelect}
      className="vx_form-control"
      noErrorClass="margin-bottom-xs"
      label=""
      {...props}
    >
      {children}
    </Field>
  </>
);

SelectionField.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  label: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  error: PropTypes.string,
  touched: PropTypes.bool,
};

SelectionField.defaultProps = {
  children: undefined,
  label: undefined,
  error: undefined,
  touched: false,
};

export default memo(SelectionField);
